/*
 * please follow the wiki: http://wiki.corp.qunar.com/pages/viewpage.action?pageId=105923056
 * @providesModule QFontSet
 */

module.exports = {
    cmn_order_rn: 'https://s.qunarzz.com/ppfe/cmn_order_rn/fonts/0.0.11/cmn_order_rn.ttf',
    cmn_order_rn_component_order: 'https://s.qunarzz.com/ppfe/cmn_component_order/fonts/0.0.9/cmn_component_order.ttf'
};
